import { Text } from "@chakra-ui/react";
import { useOrdersKanbanStore } from "../../../stores/kanban.store";

const OrdersResetFilters = () => {
	const { hasFilters, resetFilters } = useOrdersKanbanStore();

	if (!hasFilters()) return null;
	return (
		<Text
			fontSize="14px"
			fontWeight={600}
			className="text-error-600!"
			onClick={resetFilters}
			cursor="pointer"
			_hover={{
				textDecoration: "underline",
			}}
		>
			Réinitialiser les filtres
		</Text>
	);
};

export default OrdersResetFilters;
